<!-- <h1 class="mt-19">THIS IS THE RESET</h1> -->
<div id="inner-create-container" class="create-page container-fluid pb-6">
  <div class="h-100 container">
    <div class="h-100 justify-content-center align-items-center row">
      <div class="col-lg-6">
        <div class="card">
          <h4 class="card-title mt-4 spacel">Reset Password</h4>
          <div class="card-body">
            <!-- Form Section -->
            <form [formGroup]="resetPwdForm" (ngSubmit)="resetPwd()">
              <div class="form-group col-md-12 pb-2">
                <label for="newPassword" class="required">New Password</label>

                <div class="input-group">
                  <input [type]="showPassword ? 'text' : 'password'" maxlength="250" formControlName="newPassword"
                    class="form-control" placeholder="Enter New Password" />
                    <div class="input-group-append" (click)="togglePassword('password')">
                      <span class="input-group-text h-100"> <fa-icon
                      [icon]="showPassword ? faEye : faEyeSlash"></fa-icon></span>
                    </div>
                  </div>
                </div>
                @if (
                  newPassword.invalid &&
                  (newPassword.dirty || newPassword.touched)) {
                  <div class="alert alert-danger m-1">
                    Enter a valid new password.
                  </div>
                }
                <div class="form-group col-md-12 pb-2 mt-3">
                  <label for="confirmPassword" class="required">Confirm New Password</label>

                  <div class="input-group">
                    <input maxlength="250" class="form-control" placeholder="Renter New Password"
                      formControlName="confirmPassword" [type]="showConfirmPassword ? 'text' : 'password'" />
                      <div class="input-group-append" (click)="togglePassword('confirm')">
                        <span class="input-group-text h-100"> <fa-icon
                        [icon]="showConfirmPassword ? faEye : faEyeSlash"></fa-icon></span>
                      </div>
                    </div>

                  </div>
                  @if (resetPwdForm.controls['newPassword'].touched &&
                    resetPwdForm.controls['confirmPassword'].errors?.['passwordMismatch']) {
                    <div class="alert alert-danger mt-3">
                      Passwords do not match
                    </div>
                  }
                  <div class="row">
                    <div class="col mt-2">
                      <span><b>Password requirements</b></span>
                      <span class="d-flex mt-2 pb-3">
                        Passwords must be at least 8 characters in length and
                        contain at least 1 of each of the following character types:
                      </span>
                      <ul>
                        <li>Lower case letters (i.e. a-z)</li>
                        <li>Upper case letters (i.e. A-Z)</li>
                        <li>Numbers (i.e. 0-9)</li>
                        <li>Special Characters (i.e. !&#64;#$%^*()_~-=`{{ "[]:<>?,.//" }})</li>
                        <li>Note: Special Characters & and + are not permitted</li>
                      </ul>
                    </div>
                  </div>
                  <div ng-controller="Ctrl as ctrl">
                <toaster-container toaster-options="{'toaster-id': 1, 'animation-class':
                    'toast-top-left'}">
                    </toaster-container>
                    <button class="btn submit-btn mt-2 mb-2" [disabled]="!resetPwdForm.valid">
                      Reset Password
                    </button>
                  </div>
                  @if (resetFailed) {
                    <div class="alert alert-danger m-1 py-1 text-center">
                      <p>Failed to reset.</p>
                    </div>
                  }
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>